/* ========================================
   PDP - FORMATEAR ESPECIFICACIONES
   ======================================== */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-container pre').forEach(pre => {
    const text = pre.textContent.trim();
    const separator = text.includes(' - ') ? ' - ' : '. ';
    const items = text.split(separator).filter(item => item.trim());
    
    if (items.length > 1) {
      const ul = document.createElement('ul');
      ul.innerHTML = items.map(item => `<li>${item.trim()}</li>`).join('');
      pre.replaceWith(ul);
    }
  });
});
